import { render, staticRenderFns } from "./loan-tobe-collect.vue?vue&type=template&id=5b82c63e&scoped=true&"
import script from "./loan-tobe-collect.vue?vue&type=script&lang=js&"
export * from "./loan-tobe-collect.vue?vue&type=script&lang=js&"
import style0 from "./loan-tobe-collect.vue?vue&type=style&index=0&id=5b82c63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82c63e",
  null
  
)

export default component.exports